export const defaultSession = {
    isLoading: true,
    page: 'loading',

    currentAddress: null,
    availableServices: null,

    isPreorder: false,
    isKeepMeUpdated: false,
    marketID: '',
    addressID: '',
    addressZip: '',
    addressApt: '',
    address: '',
    state: '',
    cityID: '',
    cityName: '',
    iconStep: '',
    signupStep: '',
    addressResultStep: '',
    speed: '',
    speedAmount: '',
    pods: '1',
    podsAmount: '',
    tv: '',
    tvAmount: '',
    tvId: '',
    box: '',
    boxAmount: '',
    hd: '',
    hdAmount: '',
    phone: false,
    phoneId: '',
    phoneAmount: '',
    gigpromoAmount: '',
    wifipromoAmount: '',
    localfeeAmount: '',
    sportsfeeAmount: '',
    premiums: '',
    premiumsAmount: '',
    dvrAmount: '',
    battery: false,
    batteryAmount: '',
    portExistingNumber: false,
    existingNumber: '',
    line2: '',
    line2Amount: '',
    internationalAmount: '',
    total: '',
    promoID: '',
    schedule: '',
    scheduleStop: '',
    selectedPayment: '',
    selectedRef: '',
    referredBy: '',
    promoName: '',

    firstName: '',
    lastName: '',
    phoneNumber: '',
    altPhone: '',
    email: '',
    preferredContactMethod: '',
    ReceiveSMS: 'Y',
    ReceivePromotionalSMS: 'Y',
    interestedSpeed: '',
    tos: '',

    payment: '', // payment method
    account: '',
    routing: '',
    type: '', // checking type (personal vs business)
    bank: '',
    ccard: '',
    exMonth: '',
    exYear: '',
    paperBill: '',
    notes: '',
    referralType: '',
    referredBy: '',

    schedule: '',
    scheduleStop: '',

    sessID: '',
    orderId: 0,

    mainLine: '',
    fullAddress: '',
    city: '',
    apt: '',
    zip: '',
    ip: '',
    promo: null,
};
